export const useRootStore = defineStore('root', () => {
  const filtersOpen = ref<Boolean>(false)
  const showLanguageSwitcher = ref<Boolean>(false)
  const showFooter = ref<Boolean>(true)
  const footerInsetLeft = ref<Boolean>(false)
  const languages = ref<Array<string>>(['nl', 'de', 'en'])
  const lang = ref<string>('de')
  const tabId = ref<string | null>(null)
  const deviceId = ref<string | null>(null)
  const platform = ref<string | null>(null)
  const useOffset = ref<Boolean>(false)

  const toggleLanguageSwitcher = (): void => {
    showLanguageSwitcher.value = !showLanguageSwitcher.value
  }

  const loginDisabled = computed((): Boolean => {
    return !!useCartStore().shopToken
  })

  const setLanguage = (langToSet: string): void => {
    lang.value = langToSet
    if (process.client) {
      document.cookie = `lang=${lang.value};path=/;secure;SameSite=Lax`
    }
  }

  return {
    filtersOpen,
    showFooter,
    languages,
    footerInsetLeft,
    lang,
    tabId,
    deviceId,
    platform,
    showLanguageSwitcher,
    loginDisabled,
    useOffset,
    toggleLanguageSwitcher,
    setLanguage
  }
})
